<app-main-layout class="login-page">
  <app-login-form class="login-form" (authorized)="authorized($event)"></app-login-form>
</app-main-layout>
